import { Component, OnInit } from '@angular/core';
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {Router} from "@angular/router";

@Component({
    selector: 'db-upgrade-ten-web-pro',
    templateUrl: './upgrade-ten-web-pro.component.html',
    styleUrls: ['./upgrade-ten-web-pro.component.scss'],
    standalone: false
})
export class UpgradeTenWebProComponent implements OnInit {

  constructor(
    private readonly _activateModal: DbActiveModal,
    private readonly _router: Router,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit() {
    this._onModalInitEvent();
  }

  private _onModalInitEvent(): void {
    const analyticsData = {
      eventCategory: 'Booster Upgrade Offer',
      eventAction: 'Choose plan pop up',
      eventLabel: 'View'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  public chosePlan(): void {
    const _analyticsData = {
      eventCategory: 'Booster Upgrade Offer',
      eventAction: 'Choose plan pop up',
      eventLabel: 'Button click'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(_analyticsData);
    this._router.navigate(['/upgrade-plan']).then(() => {
      this._activateModal.close();
    });
  }
}
